import { Box, Flex, Text, useBreakpointValue } from "@chakra-ui/react";
import * as React from "react";
import { t } from "i18next";

function AnswerCard({ data }) {
  const dynamicStylesProps = useBreakpointValue({
    xl: {
      infoColumnWidth: "40%",
      answerColumnWidth: "60%",
      containerDisplay: "flex",
      answerMaxWidth: 350,
      infoMaxWidth: "40ch"
    },
    lg: {
      infoColumnWidth: "100%",
      answerColumnWidth: "100%",
      containerDisplay: "block",
      answerMaxWidth: 100,
      infoMaxWidth: "35ch"
    },
    md: {
      infoColumnWidth: "100%",
      answerColumnWidth: "100%",
      containerDisplay: "block",
      answerMaxWidth: 70,
      infoMaxWidth: "35ch"
    },
    sm: {
      infoColumnWidth: "100%",
      answerColumnWidth: "100%",
      containerDisplay: "block",
      answerMaxWidth: 50,
      infoMaxWidth: "30ch"
    },
    base: {
      infoColumnWidth: "100%",
      answerColumnWidth: "100%",
      containerDisplay: "block",
      answerMaxWidth: 30,
      infoMaxWidth: "30ch"
    }
  });

  const answerValue = data?.answer;
  const isNumber = answerValue !== null && answerValue !== "" && !isNaN(answerValue);

  const answer = isNumber ?
    Number(answerValue)?.toLocaleString("en-GB", { maximumFractionDigits: 4 }) ?? "" :
    typeof answerValue === "string" || answerValue === null ?
      answerValue && answerValue !== "" ?
        answerValue : "" : answerValue;

  return (
    <Flex
      width="100%"
      border="1px solid lightgray"
      borderRadius="md"
      padding={3}
      display={dynamicStylesProps.containerDisplay}
    >
      <Box width={dynamicStylesProps.infoColumnWidth}>
        <Text
          fontSize="md"
          maxWidth={dynamicStylesProps.infoMaxWidth}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          title={data.user}
        >
          <b>Assignee:</b> {data.user}
        </Text>
        <Text
          maxWidth={dynamicStylesProps.infoMaxWidth}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          title={data.supplier}
        >
          <b>Supplier:</b> {data.supplier}
        </Text>
        <Text title={t(`questionnaireStatus.${data.status}`)}>
          <b>Status:</b> {t(`questionnaireStatus.${data.status}`)}
        </Text>
        <Text title={`${data.year} ${data.quarter}`}>
          <b>Period:</b> {data.year} {data.quarter}
        </Text>
      </Box>
      <Flex width={dynamicStylesProps.answerColumnWidth} fontSize="md">
        {data.customAnswer ? data.customAnswer :
          <Text
            maxWidth={`${dynamicStylesProps.answerMaxWidth}ch`}
            whiteSpace={answer?.length > dynamicStylesProps.answerMaxWidth ? "nowrap" : "break-spaces"}
            overflow="hidden"
            textOverflow="ellipsis"
            title={typeof answer === "string" && !data.customAnswer ? answer : ""}>
            <b>Answer:</b> {data.prefix && data.prefix !== "" ? data.prefix : ""}{answer}
          </Text>
        }
      </Flex>
    </Flex>
  );
}

export default AnswerCard;